<template>
  <div class="client">
    <h1>Регистрация клиента</h1>
    <preload-content :loading="loading">
      <white-bg>
        <div>
          <div class="title">имя</div>
          <CustomInput @input="inputName" placeholder="Имя" :value="name" mb="20px"/>
          <error-text :text="errors.name"/>
        </div>
        <div>
          <div class="title">фамилия</div>
          <CustomInput @input="inputSurname" :value="surname" placeholder="Фамилия" mb="20px"/>
          <error-text :text="errors.surname"/>
        </div>
        <div>
          <div class="title">телефон</div>
          <CustomInput
            input_type="phone"
            @input="inputPhone"
            placeholder="+7 (999) 123 45 67"
            :value="phone"
            @validation_error="v => errors.phone = [v]"
          />
          <error-text :text="errors.phone"/>
        </div>
        <div>
          <ButtonComponent variant="filled" @click="register" mt="40px">Зарегистрировать</ButtonComponent>
        </div>
      </white-bg>
    </preload-content>
  </div>
</template>

<script>
import WhiteBg from '@/components/ui/white-bg';
import CustomInput from '@/components/ui/inputs/custom-input';
import ButtonComponent from '@/components/ui/buttons/button-component';
import {mapMutations} from 'vuex';
import preloadContent from '@/components/ui/preload-content';
import ErrorText from "@/components/ui/text/error-text";

export default {
  name: 'AdministratorClient',
  components: {ButtonComponent, CustomInput, WhiteBg, preloadContent, ErrorText},
  methods: {
    ...mapMutations(['openModal']),
    inputName(data) {
      this.errors.name = null;
      this.name = data;
    },
    inputSurname(data) {
      this.errors.surname = null;
      this.surname = data;
    },
    inputPhone(data) {
      this.errors.phone = null;
      this.phone = data;
    },
    register() {
      this.loading = true
      const prevPhone = this.phone
      const phone = parseInt(this.phone.replace(/\D+/g,""))
      this.phone = `+${phone}`

      this.$api.admin.clientCreate({surname: this.surname, name: this.name, phone: this.phone}).then(response => {
        this.openModal('client_create');
        this.name = null;
        this.surname = null;
        this.phone = null;
        setTimeout(() => this.$eventHub.$emit('client.create.modal.set', response.id), 0);
      }).catch(({response}) => {
        this.phone = prevPhone
        this.errors = response.data.errors
      }).finally(() => {
        this.loading = false
      });
    },
    validation_error(v) {
      console.log(v)
    }
  },
  data: () => ({
    errors: {},
    name: '',
    surname: '',
    phone: '',
    loading: false,
  })
}
</script>

<style scoped lang="scss">
.mt-20 {
  margin-top: 20px;
}

.client {
  max-width: 380px;
}

.title {
  font-family: "Open Sans", sans-serif;
  margin-left: 15px;
  font-weight: 600;
  font-size: 12px;
  line-height: 165%;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #808080;
  margin-bottom: 5px;
}

h1 {
  display: none;
}

@media screen and (max-width: 991px) {
  h1 {
    display: block;
    font-size: 24px;
    line-height: 1.33;
    color: #383838;
    margin-bottom: 15px;
    margin-top: -10px;
    padding-top: 0;
  }

  .whiteBg {
    margin: 0 -15px;
  }
}

</style>
